// Components
const ModalMultipleBrands = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-multiple-brands" */ "@/app/views/main-view/bundles/containers/bundles-container/modals/modal-multiple-brands/modal-multiple-brands.vue"
	)
const ModalMultiplePrice = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-multiple-price" */ "@/app/views/main-view/_shared/_components/modals/modal-multiple-price/modal-multiple-price.vue"
	)

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { productMixins } from "@/app/mixins/modules/product-mixins.js"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"

// Services
import BundlesService from "@/app/services/main/bundles/bundles-service"

// Constants
import { STATUS_CODES, SUBSCRIPTION_PERIOD } from "@/app/constants/constants"

export default {
	name: "BundlesContainer",
	components: {
		ModalMultipleBrands,
		ModalMultiplePrice,
	},
	mixins: [tableMixins, productMixins, toastMessageMixins],
	data() {
		return {
			isAPILoading: true,
			subPeriod: SUBSCRIPTION_PERIOD,
			modalContent: {
				bundleName: "",
				brands: [],
			},
			modalMultiplePriceContent: {},
			// table
			theads: [
				{ name: "SKU", searchLabel: "f_sku", sortLabel: "sku", isDesc: false, hasSearch: true },
				{ name: "Image", searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null },
				{ name: "Name", searchLabel: "f_name", sortLabel: "name", isDesc: false, hasSearch: true, style: null },
				{
					name: "Brand of Products",
					searchLabel: "f_brandId",
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					hasBrandSearch: true,
					style: null,
				},
				{ name: "Price", searchLabel: "f_price", sortLabel: "price", isDesc: false, hasSearch: true },
				{
					name: "Size",
					searchLabel: "f_breedSize",
					sortLabel: "breedSize",
					isDesc: false,
					hasSizeSearch: true,
				},
				{ name: "Age", searchLabel: "f_age", sortLabel: "age", isDesc: false, hasAgeSearch: true },
				// { name: "On sale", searchLabel: "f_onSale", sortLabel: "onSale", isDesc: false, hasFlagSearch: true },
				{ name: "Status", searchLabel: "f_status", sortLabel: "status", isDesc: false, hasStatusSearch: true },
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null },
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null },
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null },
			],
			// sorting
			desc: true,
			onSaleToggleCheckBox: false,
			subscriptionToggleCheckbox: false,
			oosInactiveProductToggleCheckbox: false
		}
	},
	created() {
		this.getBrandList(null)
		this.getSubscriptionPeriodList()
		this.getTableContent()
	},
	activated() {
        // this lifecycle method will only be called for components under keep-alive
        this.getTableContent();
	},
	methods: {
		checkIfDogBundle(bundles) {
			let productId = bundles.products.filter((product) => {
				if (product.productType.id === 6) {
					return product.id
				}
			})
			return productId.length
		},
		getBundleList(queryParams) {
			// search filters
			if (this.columnsFilter) {
				if (this.columnsFilter.f_sku) {
					queryParams["f_sku"] = this.columnsFilter.f_sku
				}

				if (this.columnsFilter.f_name) {
					queryParams["f_name"] = this.columnsFilter.f_name
				}

				if (this.columnsFilter.f_brandId) {
					queryParams["f_brandId"] = this.columnsFilter.f_brandId
				}

				if (this.columnsFilter.f_price) {
					queryParams["f_price"] = this.columnsFilter.f_price
				}

				if (this.columnsFilter.f_breedSize) {
					queryParams["f_breedSize"] = this.columnsFilter.f_breedSize
				}

				if (this.columnsFilter.f_age) {
					queryParams["f_age"] = this.columnsFilter.f_age
				}

				if (this.subscriptionToggleCheckbox) {
					queryParams["f_subscriptionBundle"] = this.subscriptionToggleCheckbox
				}

				if (this.columnsFilter.f_status) {
					queryParams["f_status"] = this.columnsFilter.f_status
				}

				if (this.columnsFilter.f_description) {
					queryParams["f_description"] = this.columnsFilter.f_description
				}

				if (this.onSaleToggleCheckBox) {
					queryParams["f_onSale"] = this.onSaleToggleCheckBox
				}

				if (this.oosInactiveProductToggleCheckbox) {
					queryParams["f_oosInactiveProduct"] = this.oosInactiveProductToggleCheckbox
				}
			}

			/**
			 * API Generates a Bundle for every Product we Create.
			 * We should only GET Bundles created by the USER instead of the API.
			 * */
			queryParams["f_isCustomBundle"] = true

			this.isAPILoading = true

			BundlesService.getBundles(queryParams)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination,
						}
					} else {
						this.showAPIErrorToast("Unable to fetch bundles list.", res)
					}

					this.isAPILoading = false
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAPILoading = false
				})
		},
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page
			this.getBundleList({ page, limit, sortBy, desc })
		},
		reactivateBundle(event, bundle) {
			const { name, id } = bundle

			// show modal for checked
			if (event.target.checked) {
				this.$swal({
					title: "Reactivate Doggy Pack",
					text: `Are you sure you want to reactivate ${name}?`,
					confirmButtonText: "Confirm",
					showCancelButton: true,
					cancelButtonText: "Cancel",
					reverseButtons: true,
					showCloseButton: true
				}).then((result) => {
					if (result.value) {
						// API call for reactivate
						BundlesService.reactivateBundle(id).then((res) => {
							const { SUCCESS_ACTIVATE_TITLE, SUCCESS_ACTIVATE_TEXT, ERROR_ACTIVATE_BUNDLE } =
								this.toastMessages.bundles(name)

							if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
								this.showCustomSuccessToast(SUCCESS_ACTIVATE_TITLE, SUCCESS_ACTIVATE_TEXT)
								this.isAPILoading = false
								// refresh table with filter
								this.getTableContent()
							} else {
								this.showAPIErrorToast(ERROR_ACTIVATE_BUNDLE, res)
								event.target.checked = false
								this.isAPILoading = false
							}
						})
					} else {
						event.target.checked = false
					}
				})
			}
		},
		deleteBundle(event, bundle) {
			const { name, id } = bundle

			// show modal confirmation
			if (!event.target.checked) {
				this.$swal({
					title: "Deactivate Doggy Pack",
					text: `Are you sure you want to deactivate ${name}?`,
					confirmButtonText: "Confirm",
					showCancelButton: true,
					cancelButtonText: "Cancel",
					reverseButtons: true,
					showCloseButton: true
				}).then((result) => {
					if (result.value) {
						// API call for delete
						BundlesService.deactivateBundle(id).then((res) => {
							const { SUCCESS_DEACTIVATE_TITLE, SUCCESS_DEACTIVATE_TEXT, ERROR_DEACTIVATE_BUNDLE_TEXT } =
								this.toastMessages.bundles(name)

							if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
								this.showCustomSuccessToast(SUCCESS_DEACTIVATE_TITLE, SUCCESS_DEACTIVATE_TEXT)
								this.isAPILoading = false
								// refresh table with filter
								this.getTableContent()
							} else {
								this.showAPIErrorToast(ERROR_DEACTIVATE_BUNDLE_TEXT, res)
								event.target.checked = true
								this.isAPILoading = false
							}
						})
					} else {
						event.target.checked = true
					}
				})
			}
		},
		checkIfMultipleBrands(bundleProducts) {
			// Remove Null and Duplicate Brands in a single Product List.
			const brands = [...new Set(bundleProducts.map((item) => item.brand.name))]

			return {
				name: brands.length > 1 ? "MULTIPLE BRANDS" : brands[0],
				brands,
				isMultiple: brands.length > 1,
			}
		},
		showMultipleBrands({ isMultiple, brands }, bundleName) {
			if (isMultiple) {
				this.modalContent = {
					bundleName,
					brands,
				}
				setTimeout(() => {
					this.$refs.modalMultipleBrands.show()
				}, 100)
			}
		},
		showMultiplePriceModal(bundle) {
			if (bundle.subscriptionBundle) {
				const { price: monthlyPrice, quarterlyPrice, yearlyPrice, name: bundleName } = bundle
				this.modalMultiplePriceContent = {
					name: bundleName,
					monthlyPrice,
					quarterlyPrice,
					yearlyPrice,
				}

				setTimeout(() => {
					this.$refs.modalMultiplePrice.show()
				}, 100)
			}
		},
		hasBundleImage(bundleImage) {
			let image = require("@/assets/images/temporary/product-image.png")

			if (bundleImage) {
				image = bundleImage
			}

			return image
		},
		bundleDelete(bundle) {
			this.$swal({
				title: "Delete Doggy Pack",
				text: `Are you sure you want to delete ${bundle.name}?`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true
			}).then((result) => {
				if (result.value) {
					// API call for delete
					BundlesService.bundleDelete(bundle.id).then((res) => {
						const { SUCCESS_DELETE_PRODUCT_TITLE, SUCCESS_DELETE_TEXT, ERROR_DEACTIVATE_PRODUCT_TEXT } =
							this.toastMessages.bundles(bundle.name)

						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast(SUCCESS_DELETE_PRODUCT_TITLE, SUCCESS_DELETE_TEXT)
							this.isAPILoading = false
							// refresh table with filter
							this.getTableContent()
						} else {
							this.showAPIErrorToast(ERROR_DEACTIVATE_PRODUCT_TEXT, res)
							this.isAPILoading = false
						}
					})
				}
			})
		},
		showDescriptionModal(description) {
			if (description) {
				this.$swal({
					title: "Doggy Pack Description",
					text: description,
					showCancelButton: false,
					cancelButtonText: "Cancel",
					reverseButtons: true,
					showCloseButton: true
				})
			}
		},
		handleToggleCheckbox(fieldname, event) {
			switch (fieldname) {
				case "f_onSale":
					this.onSaleToggleCheckBox = !this.onSaleToggleCheckBox
					break
				case "f_oosInactiveProduct":
					this.oosInactiveProductToggleCheckbox = !this.oosInactiveProductToggleCheckbox
					break
				default:
					this.subscriptionToggleCheckbox = !this.subscriptionToggleCheckbox
					break
			}
			this.onFilter(fieldname, event)
		},
	},
}
